/**
 * Página de Pendências - Unidades pendentes em Alvará de Funcionamento
 */
import { PendenciasTab } from '@/features/pendencias';

export default function Pendencias() {
  return <PendenciasTab />;
}
